module.exports = __webpack_public_path__ + "static/img/album01_0.30aac9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welfare/album01_0.png
// module id = aliy
// module chunks = 1